<template lang="pug">
div
  #base.round(:style="{ height: height }")
    #loader(
      v-if="isLoading"
      v-loading="isLoading"
      element-loading-text="Carregando camadas..."
    )
    #mapa.round
    transition(name="slide")
      #camadas(v-if="isCamadasOpen")
        #content
          #header
            span#title Camadas
          #body
            .item(v-for="item in camadas")
              .check
                el-checkbox(v-model="item.checked", @change="changeCheckboxCamadas", :disabled="isLoading")
                img.legend(:src="`${urlCamadas}/${item.layerId}/images/${item.legend[0].url}`" v-bind:class="{ border: item.layerId === 3 }")
              .checkbox
                span {{item.layerName}}
            .item(v-for="item in camadasButton")
              .check
                el-checkbox(v-model="item.checked", @change="changeCheckboxCamadasButton", :disabled="isLoading")
                div.legend(v-bind:class="item.class")
              .checkbox
                span {{item.layerName}}
      #camadas(v-if="isAdicionandoPonto")
        #content
          #header
            span#title Adicionar ponto
          #body
            span Selecione um ponto no mapa
</template>

<script>
import L from 'leaflet'
import * as esri from 'esri-leaflet'
import 'leaflet-easybutton'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
import HelperTopoJson from '../static/topoJsonHelper'
import { mapActions, mapState } from 'vuex'
import geral from '../constants/pa/dadosEstado/geral'

// BUG https://github.com/Leaflet/Leaflet/issues/4968
L.Marker.prototype.options.icon = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
})

const TILE_LAYER_CONFIG = {
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png',
  attribution: 'Tiles © <a href="http://www.esri.com/" target="_blank">Esri</a>'
}

const DEFAULT_CONFIG = {
  center: [-4.446367, -52.448730],
  topLeft: [2.591027, -58.898328],
  bottomRight: [-9.841153, -46.061425],
  zoom: 6,
  minZoom: 6,
  maxZoom: 17,
  attributionControl: true,
  maxBoundsViscosity: 1,
  maxBounds: [[-90, -180], [90, 180]]
}

export default {

  name: 'Mapa',

  mixins: [
    AppNotificacao
  ],

  props: {
    buttons: {
      required: false,
      type: Array,
      default: () => []
    },
    height: {
      required: false,
      type: String,
      default: '100%'
    },
    mapConfig: {
      required: false,
      type: Object
    },
    mapLayersConfigs: {
      required: false,
      type: Array
    },
    locked: {
      required: false,
      type: Boolean,
      default: false
    },
    featureLayerConfig: {
      required: false,
      type: Object
    },
    configButtonsCamadas: {
      required: false,
      default: () => [],
      type: Array
    },
    isAdicionandoPonto: {
      required: false,
      default: false,
      type: Boolean
    },
    configOrtoFotos: {
      required: false,
      type: Object
    }
  },

  data () {
    return {
      mapa: null,
      config: {},
      featureGroup: null,
      featureLayer: null,
      geomLayers: [],
      buttonsArray: [],
      isLoading: false,
      mapServer: {},
      urlCamadas: null,
      isCamadasOpen: false,
      camadas: [],
      camadasButton: [],
      camadasAtivas: [],
      hasCamadas: false,
      localLayer: null
    }
  },

  computed: {
    ...mapState({
      UTILIZA_ARCGIS: state => state.userInterface.dadosEstado.UTILIZA_ARCGIS,
      SHAPE_ESTADO: state => state.userInterface.dadosEstado.SHAPE_ESTADO,
      COORDENADAS_ESTADO: state => state.userInterface.dadosEstado.COORDENADAS_ESTADO
    })
  },

  methods: {
    ...mapActions({
      validarPonto: 'cadastro/validarPonto'
    }),

    changeCheckboxCamadas () {
      const camadasChecked = this.camadas.filter(item => item.checked).map(item => item.layerId)
      this.mapServer.setLayers(camadasChecked)
      this.$emit('camadas', this.camadas.filter(item => item.checked))
    },
    changeCheckboxCamadasButton () {
      const camadasChecked = this.camadasButton.filter(item => item.checked)
      if (this.camadasAtivas.length > 0) {
        this.camadasAtivas.forEach(camada => {
          this.mapa.removeLayer(camada)
        })
      }
      this.camadasAtivas = []
      camadasChecked.forEach(camada => {
        this.camadasAtivas.push(
          L.tileLayer.wms(process.env.URL_WMS_GEOSERVER, {
            layers: `sicarf:${camada.id}`,
            transparent: true,
            format: 'image/png'
          }).addTo(this.mapa))
      })
    },
    openCamadas (button) {
      button.state('camadas-active')
      this.isCamadasOpen = true
    },
    closeCamadas (button) {
      button.state('camadas-inactive')
      this.isCamadasOpen = false
    },
    mapServerOnLoading () {
      this.isLoading = true
    },
    mapServerOnLoad () {
      this.isLoading = false
    },
    configureLayers () {
      this.mapServer = esri.dynamicMapLayer({
        f: 'image',
        url: this.urlCamadas,
        transparent: true,
        maxZoom: DEFAULT_CONFIG.maxZoom,
        minZoom: DEFAULT_CONFIG.minZoom,
        format: 'png32',
        layers: []
      })

      this.mapServer.on('load', this.mapServerOnLoad)
      this.mapServer.on('loading', this.mapServerOnLoading)

      esri.request(`${this.urlCamadas}/legend`, {}, (_, response) => {
        if (response?.layers) {
          this.camadas = response.layers.map(item => {
            if (item.layerName === "Cursos D'Água") item.layerName = 'Cursos DAgua'
            if (item.layerName === "Massas D'Água") item.layerName = 'Massas DAgua'
            return { ...item, checked: false, isLoading: false, isLoaded: false }
          })
        }
      })

      this.mapServer.addTo(this.mapa)
    },
    async onMapClick (event) {
      if (this.isAdicionandoPonto) {
        const validacaoPonto = await this.validarPonto({lat: event.latlng.lat, lng: event.latlng.lng})

        if (validacaoPonto === 'FORA_DO_ESTADO') {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            'Selecione um ponto dentro dos limites do estado.')
          return
        }
        this.createPointMap([event.latlng.lat, event.latlng.lng])
        this.$emit('adicionarPonto', [event.latlng.lng, event.latlng.lat])
        this.$emit('changeIsAdicionandoPonto')
      }
    },
    configureButtons (receivedButtons) {
      this.buttonsArray.forEach(button => button.remove())

      this.buttonsArray = receivedButtons.map(element => {
        let item = L.easyButton({
          id: element.id,
          position: 'topleft',
          type: 'replace',
          leafletClasses: true,
          states: [{
            stateName: element.id + '-active',
            title: element.tooltip,
            icon: element.icon,
            onClick: element.onClick
          }]
        })
        item.addTo(this.mapa)
        return item
      })

      const buttonCamadas = L.easyButton({
        id: 'button-camadas',
        position: 'topleft',
        type: 'replace',
        leafletClasses: true,
        states: [{
          stateName: 'camadas-inactive',
          title: 'Camadas',
          icon: '<i class="material-icons layer-icon">layers</i>',
          onClick: (button) => this.openCamadas(button)
        },
        {
          stateName: 'camadas-active',
          title: 'Camadas',
          icon: '<i class="material-icons layer-icon">layers</i>',
          onClick: (button) => this.closeCamadas(button)
        }]
      })

      if (this.isCamadasOpen) {
        buttonCamadas.state('camadas-active')
      }
      this.buttonsArray = [...this.buttonsArray, buttonCamadas]

      if (this.UTILIZA_ARCGIS) {
        buttonCamadas.addTo(this.mapa)
      }
      if (this.configButtonsCamadas.length > 0) {
        this.camadasButton = this.configButtonsCamadas
        buttonCamadas.addTo(this.mapa)
      }
    },

    createMap () {
      // Criando mapa
      this.mapa = L.map('mapa', this.config)

      L.tileLayer(TILE_LAYER_CONFIG.url, {
        noWrap: true,
        attribution: TILE_LAYER_CONFIG.attribution
      }).addTo(this.mapa)
      this.addOrtoFotos()
      this.mapa.on('zoomend', () => this.addMapLayers())
      this.mapa.on('click', (e) => this.onMapClick(e))
      this.addMapLayers()
      this.refreshMap()

      this.lockMap(this.locked)
    },

    addOrtoFotos () {
      if (this.configOrtoFotos) {
        var wmsOptions = {
          layers: geral.CAMADAS_ORTOFOTOS,
          transparent: true,
          format: 'image/png',
          version: '1.1.0',
          maxZoom: this.configOrtoFotos.maxZoom,
          minZoom: this.configOrtoFotos.minZoom
        }
        L.tileLayer.wms(process.env.URL_WMS_ORTOFOTOS, wmsOptions).addTo(this.mapa)
        // set maxZoom do mapa base para pode bater com o coom da camada de ortofotos
        this.mapa.setMaxZoom(this.configOrtoFotos.maxZoom)
      }
    },

    addFeatureLayer () {
      if (this.featureLayerConfig) {
        const { url, popup } = this.featureLayerConfig

        this.featureLayer = esri.dynamicMapLayer({
          url,
          useCors: false,
          format: 'png32',
          layers: [0],
          maxZoom: DEFAULT_CONFIG.maxZoom,
          minZoom: DEFAULT_CONFIG.minZoom
        })

        if (popup) {
          this.featureLayer.bindPopup(popup)
        }

        this.featureLayer.on('load', () => !this.hasCamadas ? this.addMapLayers() : null)

        this.featureLayer.addTo(this.mapa)
      }
    },

    addMapLayers () {
      if (this.featureGroup) {
        this.mapa.removeLayer(this.featureGroup)
      }
      this.featureGroup = new L.FeatureGroup()

      if (this.mapLayersConfigs && this.mapLayersConfigs.length > 0) {
        this.mapLayersConfigs.forEach((layerConfig) => {
          const { geoJson, tooltip, popup, style, click, idGeometria, ponto, area } = layerConfig

          if (geoJson?.type === 'Point') {
            this.addPointLayer({...this.layerConfig, geoJson: geoJson, style: this.featureLayerConfig.style})
          } else {
            let geometry

            // Calcula quando transformar o polygon em ponto baseado na area e no zoom
            if (DEFAULT_CONFIG.maxZoom - this.mapa.getZoom() * 2 > area * 100) {
              geometry = L.marker([ponto.coordinates[1], ponto.coordinates[0]]).addTo(this.featureGroup)
              geometry.on('click', (event) => this.mapa.fitBounds(L.geoJSON(geoJson, { style }).getBounds()))
            } else {
              geometry = L.geoJSON(geoJson, { style })

              if (tooltip) {
                geometry.bindTooltip(tooltip)
              }

              if (popup) {
                geometry.bindPopup(popup.container, popup.config)
              }

              if (click) {
                geometry.on('click', click)
              }

              if (idGeometria >= 0) {
                geometry.on('click',

                  () => {
                    document.getElementById('remover-geometria-button[' + idGeometria + ']')
                      .addEventListener('click', (event) => {
                        this.confirmBox(this.$messages.GEOMETRIA_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
                          () => {
                            this.featureGroup.removeLayer(this.featureGroup.getLayerId(geometry))
                            this.$emit('removerGeometria', idGeometria)
                          },
                          () => {
                            this.$refs.mapa.closePopup()
                          })
                      })
                  }

                )
              }
            }

            geometry.addTo(this.featureGroup)
            this.geomLayers.push(geometry)
          }
        })
      }
      this.hasCamadas = true
      this.mapa.addLayer(this.featureGroup)
    },

    recenterView () {
      if (this.UTILIZA_ARCGIS) {
        this.mapa.fitBounds([DEFAULT_CONFIG.topLeft, DEFAULT_CONFIG.bottomRight])
      } else {
        this.mapa.fitBounds(this.localLayer.getBounds())
      }
    },

    createPointMap (latLng) {
      const newMarker = L.marker(latLng).addTo(this.mapa)

      newMarker.on('click', () => {
        this.confirmBox('Deseja remover esse ponto?', this.$messages.TITULO_WARNING,
          () => {
            this.mapa.removeLayer(newMarker)
            this.$emit('removerGeometria', 0)
          },
          () => {
            this.$refs.mapa.closePopup()
          }
        )
      })

      return newMarker
    },

    addPointLayer (layerConfig) {
      L.geoJson(layerConfig.geoJson, {

        pointToLayer: (marker, latlng) => {
          return this.createPointMap([latlng.lat, latlng.lng])
        }
      }).addTo(this.featureGroup)
    },

    configureMap () {
      for (let propertyName in DEFAULT_CONFIG) {
        this.config[propertyName] = this.mapConfig && this.mapConfig[propertyName]
          ? this.mapConfig[propertyName] : DEFAULT_CONFIG[propertyName]
      }
    },

    closePopup () {
      if (this.mapa) this.mapa.closePopup()
    },

    refreshMap () {
      if (this.featureGroup && this.featureGroup.getBounds()) {
        if (Object.keys(this.featureGroup.getBounds()).length > 0) {
          this.mapa.invalidateSize()
          this.mapa.fitBounds(this.featureGroup.getBounds())
        }
      }
    },

    clearLayers () {
      if (this.featureGroup) {
        this.mapa.removeLayer(this.featureGroup)
        this.featureGroup = null
      }
    },

    lockMap (mapLock) {
      let lockFunc = 'enable'
      if (mapLock === true) {
        lockFunc = 'disable'
      }

      this.mapa.dragging[lockFunc]()
      this.mapa.touchZoom[lockFunc]()
      this.mapa.doubleClickZoom[lockFunc]()
      this.mapa.scrollWheelZoom[lockFunc]()
      this.mapa.boxZoom[lockFunc]()
      this.mapa.keyboard[lockFunc]()

      if (this.mapa.tap) this.mapa.tap[lockFunc]()
    }

  },

  created () {
    this.urlCamadas = process.env.URL_MAPSERVER_CAMADAS
  },

  mounted () {
    this.configureMap()

    if (!this.mapa) {
      this.createMap()
    }

    if (this.UTILIZA_ARCGIS) {
      this.addFeatureLayer()
    } else {
      this.$nextTick().then(() => {
        HelperTopoJson.getTopoJson().then((layerMunicipios) => {
          this.mapa.addLayer(layerMunicipios)
          this.mapa.fitBounds(layerMunicipios.getBounds())
          this.localLayer = layerMunicipios
        })
      })
    }

    this.configureButtons(this.buttons)

    this.configureLayers()
  },

  watch: {
    mapLayersConfigs: {

      handler (val, old) {
        if (val !== old) {
          this.clearLayers()
          this.addMapLayers()
          this.refreshMap()
        }
      },

      deep: true
    },
    buttons: {
      handler (val) {
        this.configureButtons(val)
      },
      deep: true
    }
  }
}

</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.round {
  border-radius: 10px;
}

#base {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

#loader {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 1000;
}

#mapa {
  height: 100%;
  width: 100%;
}

#camadas {
  z-index: 1000;
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  left: 54px;
  top: 10px;

  #content {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: flex-start;
    min-width: 15rem;
    max-width: 17rem;
    border-radius: 4px;
    background-color: $white;
    cursor: default;

    #header {
      width: 100%;
      height: 36px;
      background-color: $color-primary;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      #title {
        color: $white;
        font-size: 1rem;
        font-weight: bold;
        margin-left: 0.75rem;
      }
    }
    #body {
      width: 100%;
      padding: 0.75rem;
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      align-items: flex-start;
      max-height: 500px;
      overflow: overlay;

      .item {
        padding-top: 0.15rem;
        padding-bottom: 0.15rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .check {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-right: 0.5rem;

          .legend {
            margin-left: 0.5rem;
            height: 14px;
            width: 14px;
          }
          .malha-maranhao-polygon {
            border: 2px solid rgb(240, 243, 55);
            background-color: rgba(251, 255, 7, 0.8);
          }
          .sicarf-processos-ma {
            border: 2px solid rgb(50, 207, 30);
            background-color: rgba(50, 207, 30, 0.8);
          }
        }

        .checkbox {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          flex: 1;
        }
      }
    }
  }
}

.border {
  border: 1px $font-dark-color solid;
}

.slide-enter-active {
  transition: all 0.5s;
}
.slide-leave-active {
  transition: all 0.5s;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-58px);
  opacity: 0;
}
</style>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.state-camadas-active {
  color: $color-primary;
}

.easy-button-button {
  border: none !important;
  padding: 0px !important;
  width: 30px !important;
  height: 30px !important;

  border-radius: 2px;
  background-color: #ffffff;
}

.easy-button-button:hover {
  background-color: #f4f4f4;
}

.upload-active {
  width: 30px !important;
  height: 30px !important;
}

.leaflet-control-zoom-in {
  width: 30px !important;
}

.leaflet-control-zoom-out {
  width: 30px !important;
}

.layer-icon {
  margin-top: 2px;
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppMapa.vue